import React, { FC } from "react"
import { StatusBubble } from "../../atoms/Atoms"
import { RRIconBar } from "../../atoms/roundedrectangle/RRIconBar"
import { RoundedRectangle } from "../../atoms/roundedrectangle/RoundedRectangle"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../../atoms/Bodies"
import { CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"
import { FormattedMessage, useIntl } from "react-intl"

const CarrotCardRestrictionPeriodModule: FC<CarrotCardModuleProps> = () => {
  const intl = useIntl()
  return (
    <RoundedRectangle backgroundColor="red-orange-white">
      <RRIconBar
        iconName="icn-carrot-cards"
        iconBackgroundColor="roman-red-40"
        label={<StatusBubble backgroundColor="roman-red" status={intl.formatMessage({ defaultMessage: "Locked" })} />}
      />
      <H3 variant="primary" stack="tiny">
        <FormattedMessage defaultMessage="Carrot Card®" />
      </H3>
      <BodySmall color="black-80">
        <FormattedMessage defaultMessage="Due to your employer’s end-of-year payroll policies, your Carrot Card is locked until January 1." />
      </BodySmall>
    </RoundedRectangle>
  )
}

export { CarrotCardRestrictionPeriodModule }
